module.exports = __webpack_public_path__ + "static/media/payments.65d3f4ba.svg";